import { DiagnosticLevel, TelemetryEvent, logNotification, LogLevel, Category } from '@ms/oteljs';
import { Preprocessor } from './Preprocessor';

/**
 * Determines whether an event can be sent based on its data classification.
 * Please consult with your privacy champion before enabling a full events override.
 */
export class DataClassificationChecker implements Preprocessor {
  private _fullEventsEnabled: boolean = false;

  /**
   * Determine whether an event can be sent. Generally returns true; returns
   * false if the event does not have the appropriate event flags and the full events override is not enabled.
   * @param telemetryEvent - An event to process
   */
  public processEvent(telemetryEvent: TelemetryEvent) {
    if (!this._fullEventsEnabled && !telemetryEvent.eventFlags) {
      throw new Error(`${telemetryEvent.eventName} missing Event Flags`);
    }

    let eventSuccess: boolean =
      this._fullEventsEnabled ||
      (!!telemetryEvent.eventFlags &&
        (telemetryEvent.eventFlags.diagnosticLevel === DiagnosticLevel.BasicEvent ||
          telemetryEvent.eventFlags.diagnosticLevel === DiagnosticLevel.NecessaryServiceDataEvent ||
          telemetryEvent.eventFlags.diagnosticLevel === DiagnosticLevel.AlwaysOnNecessaryServiceDataEvent));

    if (!eventSuccess) {
      logNotification(LogLevel.Info, Category.Sink, () => {
        return `1DS Data Classification Failed to Send: ${telemetryEvent.eventName}`;
      });
    }

    return eventSuccess;
  }

  /**
   * Override to send all events as Full Events. Enabling this should be used with caution.
   * This will ignore users privacy settings.
   * @param enabled - Determines if all events should be sent as full events.
   */
  public setFullEventsEnabled(enabled: boolean) {
    this._fullEventsEnabled = enabled;
  }
}
